window.addEventListener("load", function () {
  var $sw = $("#swiperMonphai");
  if ($sw.length > 0) {
    var swiper = new Swiper("#swiperMonphai", {
      slidesPerView: "auto",
      centeredSlides: false,
      // spaceBetween âm để bù phần dư của slide thu nhỏ → khe giữa các hình nhỏ & đều
      spaceBetween: -80,
      breakpoints: {
        769: { spaceBetween: -120 },
      },
      watchSlidesProgress: true,
    });

    var $slides = $sw.find(".swiper-slide");

    function currentIndex() {
      return $slides.index($slides.filter(".is-active"));
    }
    function setActive(i) {
      if (i < 0 || i > $slides.length - 1) return; // ngoài biên: bỏ qua
      $slides.removeClass("is-active").eq(i).addClass("is-active");
      return i;
    }
    // Cuộn tối thiểu để slide i lọt hẳn vào khung (canh mép gần nhất, không nhảy về đầu)
    function scrollIntoView(i) {
      var cont = swiper.width;
      var t = swiper.translate;
      var left = swiper.slidesGrid[i] + t;
      var right = left + swiper.slidesSizesGrid[i];
      var nt = t;
      if (left < 0) nt = t - left; // lòi bên trái → kéo mép trái về 0
      else if (right > cont) nt = t - (right - cont); // lòi bên phải → kéo mép phải về cont
      nt = Math.max(swiper.maxTranslate(), Math.min(swiper.minTranslate(), nt));
      if (nt !== t) swiper.translateTo(nt, 300);
    }

    // Click slide nào → slide đó active (to + sáng) tại chỗ (slide đang thấy nên không cuộn).
    // Chưa active: chỉ đổi active (chặn link); đang active: mở link.
    $(document).on("click", "#swiperMonphai .swiper-slide", function (e) {
      if (!$(this).hasClass("is-active")) {
        e.preventDefault();
        setActive($slides.index(this));
      }
    });

    // Mũi tên: active slide trước / sau + cuộn để nó lọt vào khung
    $(".swiper-button-prev--mp").on("click", function () {
      var i = setActive(currentIndex() - 1);
      if (i != null) scrollIntoView(i);
    });
    $(".swiper-button-next--mp").on("click", function () {
      var i = setActive(currentIndex() + 1);
      if (i != null) scrollIntoView(i);
    });
  }
});
